import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBhQYtwCbvDAnQHrM5T7idC1-vwuhd5MWQ",
  authDomain: "clients-profiling.firebaseapp.com",
  projectId: "clients-profiling",
  storageBucket: "clients-profiling.firebasestorage.app",
  messagingSenderId: "953439251399",
  appId: "1:953439251399:web:9fa3dbfb8ca2592c7987e2"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export { firebaseConfig };
export default app;
